import { useContext } from "react"
import { EventViewsList, SimpleDefinitionListItem } from "@components"
import { ContextualSidebarContext } from "@context"
import { GET_DASHBOARD_EVENT_VIEWS_STATS } from "@graphql"
import { Button } from "@heroui/react"
import { CalendarIcon, CalendarDaysIcon, ChevronLeftIcon, SignalIcon, UserCircleIcon } from "@heroicons/react/24/outline"
import { useQuery } from "@apollo/client"
import PropTypes from "prop-types"

const EventViews = ({ event, user }) => {
  const { setContextualSidebar } = useContext(ContextualSidebarContext)
  
  const eventViews = useQuery(GET_DASHBOARD_EVENT_VIEWS_STATS, {
    variables: { input: { event_id: event.id, teacher_id: user.id } },
    pollInterval: 120000,
    fetchPolicy: "network-first",
  })

  const getEventViewsSubTitle = filter => {
    switch (filter) {
      case "LIVE":
        return "People currently viewing this event."
      case "ALL":
        return "All unique views of this event."
      case "TODAY":
        return "Unique views of this event today."
      case "LAST_3_DAYS":
        return "Unique views of this event in the last 3 days."
      default:
        return "Views of this event."
    }
  }

  const handleBack = () => {
    setContextualSidebar({ 
      open: true, 
      title: "Event Views", 
      subTitle: "See who has viewed this event", 
      content: <EventViews event={event} user={user} />, 
      size: "lg" 
    })
  }

  const handleShowEventViews = filter => {
    setContextualSidebar(prevState => ({
      ...prevState,
      open: true,
      title: "Event Views",
      subTitle: getEventViewsSubTitle(filter),
      content: <EventViewsList 
        eventId={event.id} 
        filter={filter} 
        endSlot={<Button color="success" size="lg" className="font-semibold text-white" fullWidth onPress={() => handleBack()}>
          <ChevronLeftIcon className="h-6 text-white" /> Back To Views Menu</Button>
        } 
        teacherId={user.id} 
      />,
      size: "lg",
    }))
  }

  return (
    <div>
      <h2 className="mb-1 text-lg font-semibold text-foreground">Event Views</h2>
      <p className="mb-4 text-content2-foreground">Details of your invited guardians who have viewed this event in the parents portal.</p>
      
      <SimpleDefinitionListItem 
        caption="Total Live Views" 
        description={eventViews?.data?.views?.total_live} 
        icon={<SignalIcon className="w-7 h-7" />} 
        isLink={true} 
        onPress={() => handleShowEventViews("LIVE")}
      />

      <SimpleDefinitionListItem 
        caption="Total Unique Views" 
        description={eventViews?.data?.views?.total} 
        icon={<UserCircleIcon className="w-7 h-7" />} 
        isLink={true} 
        onPress={() => handleShowEventViews("ALL")}
      />

      <SimpleDefinitionListItem 
        caption="Unique Views Today" 
        description={eventViews?.data?.views?.total_today} 
        icon={<CalendarIcon className="w-7 h-7" />} 
        isLink={true} 
        onPress={() => handleShowEventViews("TODAY")}
      />

      <SimpleDefinitionListItem 
        caption="Unique Views Last 3 Days" 
        description={eventViews?.data?.views?.total_last_3_days} 
        icon={<CalendarDaysIcon className="w-7 h-7" />} 
        isLink={true} 
        onPress={() => handleShowEventViews("LAST_3_DAYS")}
      />
    </div>
  )
}

EventViews.propTypes = {
  event: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
}

export default EventViews
